import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { SessionService } from './hub-components/services/session/session.service';
import { User } from './hub-components/models/user.model';
import { Account } from './hub-components/models/account.model';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent implements OnInit {
  private user: User;
  private account: Account;

  constructor(
    private renderer: Renderer2,
    private sessionService: SessionService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public ngOnInit() {
    this.user = this.sessionService.user;
    this.account = this.sessionService.account;
    this.configJimo();
  }

  private configJimo() {
    if (window['JIMO_PROJECT_ID'] || this.sessionService.isPublic) {
      return;
    }

    window['jimo'] = [];
    const script = this.renderer.createElement('script');
    window['JIMO_PROJECT_ID'] = '4d56bfe2-2c9d-4531-bc23-de2b4e7fe11f';
    this.renderer.setAttribute(script, 'type', 'text/javascript');
    this.renderer.setAttribute(script, 'async', 'true');
    this.renderer.setAttribute(script, 'src', 'https://undercity.usejimo.com/jimo-invader.js');
    this.renderer.appendChild(this.document.head, script);
    this.identifyUser();
  }

  private identifyUser() {
    window['jimo'].push([
      'do',
      'identify',
      [
        this.user.name,
        () => {
          window['jimo'].push(['set', 'user:email', [this.user.email]]);
          window['jimo'].push(['set', 'user:attributes', [ {account: this.account.name, suite: this.user.suite} ]]);
        },
      ],
    ]);
  }
}
